import React, {useEffect, useState} from 'react';
import commonPaying from '../../../assets/motion/commonPaying.json'
import '../../../css/web/CommonLoading.css';
import Lottie from "lottie-react";
import { serverLog } from '../../../utils/ServerLog';
import axios from "axios";

// 수신은 모두 가능하지만 웹 & 모바일웹의 국내결제(2 Type)만 DB 저장
function PaymentLoading() {

    const [paymentFailed, setPaymentFailed] = useState(false);

    // 쿼리스트링 파라미터를 모두 객체로 반환
    const getQueryParams = () => {
        try {
            const params = new URLSearchParams(window.location.search);
            let obj = {};
            for (let [key, value] of params.entries()) {
                obj[key] = value;
            }
            return obj;
        } catch (err) {
            serverLog("getQueryParams error:", err);
            console.error("getQueryParams error:", err);
            return {};
        }
    };

    useEffect(() => {
        try {
            const params = getQueryParams();

            // 파라미터
            const mbNum = params.mbNum;
            const easyPassword = params.easyPassword;
            const payNum = params.payNum;
            const cardPgInfo = params.cardPgInfo;
            const type = params.type;

            // 국내 자동결제 여부확인
            const isAutoPay = params.payNum && params.pgcode && params.card_info && params.easyPassword && params.billkey;
            const isNormalPay = !isAutoPay && params.tid && params.tid.startsWith("bt_kr_pay-")

            if (!isAutoPay && !isNormalPay) {
                return;
            }

            serverLog("웹 - 추출된 Params : ", params)
            console.log("웹 - 추출된 Params : ", params)

            serverLog("웹 - 자동결제 | 일반결제 : ", isAutoPay + " | " + isNormalPay)
            console.log("웹 - 자동결제 | 일반결제 : ", isAutoPay + " | " + isNormalPay)

            if (isAutoPay) {
                // 국내 자동결제
                const saveAutoPay = async () => {
                    try {
                        await axios({
                            method: "post",
                            url: "/btoragePay/saveDsInputPayInfo",
                            params: {
                                mbNum,
                                easyPassword,
                                payNum,
                                cardPgInfo,
                                type,
                            },
                            data: { ...params },
                        });
                    } catch (err) {
                        setPaymentFailed(true);
                        serverLog("국내 자동결제 실패", err);
                        console.error("국내 자동결제 실패", err);
                    }
                };

                saveAutoPay();

            } else {
                // 국내 일반결제
                const saveNormalPay = async () => {
                    try {
                        await axios({
                            method: "post",
                            url: "/btoragePay/saveDsTempPayNum",
                            params: {
                                mbNum,
                                payNum,
                                type,
                            },
                            data: { ...params },
                        });
                    } catch (err) {
                        setPaymentFailed(true);
                        serverLog("국내 일반결제 실패", err);
                        console.error("국내 일반결제 실패", err);
                    }
                };

                saveNormalPay();
            }

        } catch (err) {
            setPaymentFailed(true);
            serverLog("콜백수신 후 결제정보 저장오류 : ", err);
            console.error("콜백수신 후 결제정보 저장오류 : ", err);
        }
    }, []);

    return (
        <div className="loading-container font-t-cont" style={{backgroundColor: "white"}}>
            <div className="position-relative user-center wd-250 ht-250">
                <div className="flex-column align-items-center justify-content-center">
                    <Lottie
                        animationData={commonPaying}
                        loop
                        autoplay
                    />

                    {!paymentFailed ?
                        <div className="text-center m-t-20" style={{opacity: "0.6"}}>
                            <p style={{color: "#121212", margin: "15px 0", fontSize: "21px"}}>Payment in progress ...</p>
                            <p style={{color: "#EF5523", fontSize: "15px"}}>Do not close the payment window</p>
                            <p style={{color: "#EF5523", fontSize: "15px"}}>(결제창을 닫지마세요)</p>
                        </div>
                        :
                        <div className="text-center m-t-20" style={{opacity: "0.6"}}>
                            <p style={{color: "#121212", marginTop: "15px", fontSize: "21px"}}>Payment Failed! &#128514;</p>
                            <p style={{color: "#EF5523", fontSize: "15px", fontWeight: "bold"}}>Please contact Btorage</p>
                            <p style={{color: "#EF5523", fontSize: "15px", fontWeight: "bold"}}>비토리지로 문의주세요</p>
                        </div>
                    }

                </div>
            </div>
        </div>
    );
}

export default PaymentLoading;
